import React from 'react';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import LOOKUP from 'constants/lookup';
import Button from 'screens/components/basic/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "MemberDemographic";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    fullWidth={true}
                    defaultValue={"0"}
                    label={LOOKUP.report.common.branch}
                    floatingLabelText={LOOKUP.report.common.branch}
                    hintText={LOOKUP.report.common.branch}
                    options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
